import React from "react";

class Nav extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <nav
        className="breadcrumb has-arrow-separator mt-6 is-block"
        aria-label="breadcrumbs"
      >
        <ul className="pt-4" id="footer-nav">
          <li className={this.props.isCaseOverview}>Part 1: Case Overview</li>
          <li className={this.props.isMedicalRecordsUpload}>
            Part 2: Medical Records Upload
          </li>
          <li className={this.props.isTermsAndConditions}>
            Part 3: Terms and Conditions
          </li>
          <li className={this.props.isPayment}>
            Part 4: Checkout
          </li>
        </ul>
      </nav>
    );
  }
}

export default Nav;
